// Produktseite (iso_reader_detail.html5): Alt-Texte, Sprung zu den
// Bewertungen, mobile Kaufleiste, Groessenwahl als Chips und der
// Mengenwaehler.

const detailTitel = document.querySelector('.detail_header_container .right h1, .detail_header_container .right h2');

// Leere alt-Attribute der Produktbilder mit dem Produktnamen fuellen
if (detailTitel) {
    const name = detailTitel.textContent.trim();

    document.querySelectorAll('.mainImage img, .gallerySwiper img').forEach((bild) => {
        if (!bild.getAttribute('alt')) {
            bild.setAttribute('alt', name);
        }
    });
}


// Sprung zu den Bewertungen. Die Bewertungen gelten dem Shop, nicht dem
// einzelnen Artikel - das muss die Beschriftung auch sagen.
const bewertungsKasten = document.querySelector('.review-link');
const bewertungsText = document.querySelector('.review-link-count');
const bewertungsZahl = document.querySelectorAll('.reviews .review').length;

if (bewertungsKasten && bewertungsText && bewertungsZahl) {
    bewertungsText.textContent = bewertungsZahl === 1
        ? '1 Shop-Bewertung ansehen'
        : bewertungsZahl + ' Shop-Bewertungen ansehen';

    // Wenn die Bewertungen weiter unten einen Durchschnitt haben, gehoert
    // die Zahl nach oben zum Preis - dort schaut man hin, bevor man sich
    // entscheidet. Ohne Sternewertungen bleibt es bei der reinen Anzahl.
    const schnitt = document.querySelector('.ce_rsce_bewertungen .fn-schnitt');

    if (schnitt) {
        const sterne = schnitt.querySelector('.fn-sterne');
        const wert = schnitt.querySelector('strong');

        if (sterne && wert) {
            bewertungsKasten.classList.add('hat-schnitt');
            bewertungsText.textContent = '';
            bewertungsText.appendChild(sterne.cloneNode(true));
            bewertungsText.insertAdjacentText('beforeend', ' ' + wert.textContent + ' von 5');
            bewertungsText.insertAdjacentHTML(
                'beforeend',
                ' <span class="review-link-anzahl">&middot; ' + bewertungsZahl + ' Bewertungen</span>'
            );
        }
    }

    bewertungsKasten.hidden = false;

    bewertungsKasten.querySelector('.review-link-btn').addEventListener('click', () => {
        const ziel = document.getElementById('bewertungen');

        if (ziel) {
            ziel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });
}


// Kaufleiste am unteren Rand, sobald der echte Kaufknopf aus dem Blickfeld
// gescrollt ist.
const kaufLeiste = document.querySelector('.sticky-buy');
const kaufKnopf = document.querySelector('.submit_container input[name="add_to_cart"]');

if (kaufLeiste && kaufKnopf) {
    // Die Leiste liegt fest am unteren Rand - der Seitenfuss und der
    // Cookie-Knopf brauchen den Platz darueber.
    document.body.classList.add('hat-kaufleiste');

    if (detailTitel) {
        kaufLeiste.querySelector('.sticky-buy-name').textContent = detailTitel.textContent.trim();
    }

    kaufLeiste.querySelector('.sticky-buy-btn').addEventListener('click', () => kaufKnopf.click());

    const zeigen = (an) => {
        kaufLeiste.hidden = !an;
        kaufLeiste.setAttribute('aria-hidden', an ? 'false' : 'true');
    };

    if ('IntersectionObserver' in window) {
        const beobachter = new IntersectionObserver((eintraege) => {
            eintraege.forEach((eintrag) => {
                zeigen(!eintrag.isIntersecting && eintrag.boundingClientRect.top < 0);
            });
        }, { threshold: 0 });

        beobachter.observe(kaufKnopf);
    } else {
        // Ohne IntersectionObserver bleibt die Leiste dauerhaft stehen -
        // lieber immer sichtbar als nie.
        zeigen(true);
    }
}


// Groessenwahl als Chips statt Auswahlfeld - auf dem Handy deutlich
// schneller zu treffen als ein Dropdown.
const chipsBauen = () => {
    const bereich = document.querySelector('.detail_header_container .right .options');

    if (!bereich) {
        return;
    }

    bereich.querySelectorAll('select').forEach((auswahl) => {
        if (auswahl.dataset.fnChips || auswahl.options.length < 2 || auswahl.multiple) {
            return;
        }

        auswahl.dataset.fnChips = '1';

        const reihe = document.createElement('div');
        reihe.className = 'fn-groessen';

        const chips = [];

        const standSetzen = () => {
            chips.forEach((chip) => {
                chip.knopf.setAttribute('aria-pressed', chip.wert === auswahl.value ? 'true' : 'false');
            });
        };

        Array.prototype.forEach.call(auswahl.options, (option) => {
            if (option.value === '') {
                return;
            }

            const chip = document.createElement('button');
            chip.type = 'button';
            chip.className = 'fn-groessen-chip';
            chip.textContent = option.text;
            chip.disabled = option.disabled;
            chip.setAttribute('aria-pressed', option.selected ? 'true' : 'false');

            chip.addEventListener('click', () => {
                auswahl.value = option.value;
                auswahl.dispatchEvent(new Event('change', { bubbles: true }));
                standSetzen();
            });

            chips.push({ knopf: chip, wert: option.value });
            reihe.appendChild(chip);
        });

        auswahl.addEventListener('change', standSetzen);
        auswahl.classList.add('fn-select-versteckt');
        auswahl.parentNode.insertBefore(reihe, auswahl.nextSibling);
        standSetzen();
    });
};


// Mengenfeld als Stepper - ein Zahlenfeld mit winzigen Pfeilen trifft man
// auf dem Handy nicht.
const stepperBauen = () => {
    const feld = document.querySelector('.quantity_container input[name="quantity_requested"]');

    if (!feld || feld.dataset.fnStepper) {
        return;
    }

    feld.dataset.fnStepper = '1';

    if (!feld.value) {
        feld.value = feld.placeholder || '1';
    }

    const huelle = document.createElement('div');
    huelle.className = 'fn-menge';
    feld.parentNode.insertBefore(huelle, feld);

    const knopf = (zeichen, schritt) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.textContent = zeichen;
        b.setAttribute('aria-label', schritt > 0 ? 'Menge erhöhen' : 'Menge verringern');

        b.addEventListener('click', () => {
            let wert = parseInt(feld.value || feld.placeholder || '1', 10);

            if (isNaN(wert)) {
                wert = 1;
            }

            feld.value = Math.max(1, wert + schritt);
            feld.dispatchEvent(new Event('change', { bubbles: true }));
        });

        return b;
    };

    huelle.appendChild(knopf('−', -1));
    huelle.appendChild(feld);
    huelle.appendChild(knopf('+', 1));
};

chipsBauen();
stepperBauen();

// Isotope tauscht die Optionen nach einer Variantenwahl per AJAX aus
const optionenBereich = document.querySelector('.detail_header_container .right');

if (optionenBereich && window.MutationObserver) {
    new MutationObserver(() => chipsBauen()).observe(optionenBereich, { childList: true, subtree: true });
}
